import { render, staticRenderFns } from "./modvertical.vue?vue&type=template&id=7f4410e9"
import script from "./modvertical.vue?vue&type=script&lang=js"
export * from "./modvertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports